module.exports = __webpack_public_path__ + "static/mitre10-bg-desktop-25d23ee948b658e17e05084531c3efff.jpg";